import { render } from "./shops_detail_block.vue?vue&type=template&id=61a41537&scoped=true"
import script from "./shops_detail_block.vue?vue&type=script&lang=js"
export * from "./shops_detail_block.vue?vue&type=script&lang=js"

import "./shops_detail_block.vue?vue&type=style&index=0&id=61a41537&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a41537"]])

export default __exports__